// src/routes/dashboard/components/RecentRequestsList.tsx
import React from 'react';
import { Badge, Card, Group, Stack, Text, Title, Box } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { HomeRequestItem } from '../../../types/api';
import { TYPE_META, STATUS_META } from '../../../components/analytics/analytics-meta';

interface RecentRequestsListProps {
  items: HomeRequestItem[];
}

export function RecentRequestsList({ items }: RecentRequestsListProps) {
  const navigate = useNavigate();

  const openRequest = (id: number) => {
    navigate({ to: `/requests/${id}`, search: { from: '/' } } as any);
  };

  return (
    <Card withBorder p="md" h="100%">
      <Title order={4} mb="sm">
        Richieste recenti
      </Title>

      {items.length === 0 ? (
        <Text size="sm" c="dimmed" ta="center" py="lg">
          Nessuna richiesta recente
        </Text>
      ) : (
        <Stack gap="xs">
          {items.map((item) => (
            <Group
              key={item.id}
              justify="space-between"
              wrap="nowrap"
              p="xs"
              style={{ cursor: 'pointer', borderRadius: 6 }}
              onClick={() => openRequest(item.id)}
            >
              <Group gap="xs" wrap="nowrap" style={{ minWidth: 0, flex: 1 }}>
                <Badge color={TYPE_META[item.type]?.mantineColor ?? 'gray'} variant="light" size="sm">
                  {item.progressiveNumberFormatted}
                </Badge>
                <Box style={{ minWidth: 0 }}>
                  <Text size="sm" fw={500} truncate>
                    {item.title || item.clientName || 'Senza titolo'}
                  </Text>
                  <Text size="xs" c="dimmed" truncate>
                    {item.clientName}
                  </Text>
                </Box>
              </Group>
              <Badge color={STATUS_META[item.status]?.mantineColor ?? 'gray'} variant="dot" size="sm">
                {STATUS_META[item.status]?.label ?? item.status}
              </Badge>
            </Group>
          ))}
        </Stack>
      )}
    </Card>
  );
}
